import { observable, action, runInAction } from 'mobx'
import { message } from 'hljd'

import Api from '@api/cashier'
import { OrderStatusEnum } from '@api/cashier/types'

const TransWayChannel = {
  1: 21,
  2: 11
}

class Store {
  price //需要支付价格
  order_id //订单列表中的订单id
  trade_no //订单号
  title //订单标题
  return_url //支付完成后的回调地址
  payStatus // 支付状态
  payParams //支付时需要传的参数
  checkParams //检测是否支付的信息

  @observable payType = 2 //默认支付方式，若没有传值则默认为2
  @action
  changePayType = e => {
    this.payType = e.target.value
    clearInterval(this.timeout)
  }

  @observable cardPayVisible = false

  @observable user_name = ''
  @observable user_idcard = ''
  @observable user_bankcard = ''
  @observable user_phone = ''

  @observable
  changeValue = type => e => {
    this[type] = e.target.value
  }

  @action
  toSubmit = () => {
    const { user_name, user_idcard, user_bankcard, user_phone } = this
    if (!user_name) {
      return message.warning('输入本人真实姓名！')
    }
    if (!user_idcard) {
      return message.warning('请输入身份证号！')
    }
    if (!user_bankcard) {
      return message.warning('请输入银行卡号！')
    }
    if (!user_phone) {
      return message.warning('请输入银行手机号！')
    }

    this.cardPay()
  }

  @action
  closeModal = () => {
    clearInterval(this.timeout)
    this.cardPayVisible = false
    this.user_name = ''
    this.user_idcard = ''
    this.user_bankcard = ''
    this.user_phone = ''
  }

  @observable weiXinVisible = false
  @observable payQrCode = ''

  @action
  close = () => {
    this.weiXinVisible = false
    clearInterval(this.timeout)
  }

  @action
  toPay = async () => {
    const { payType, order_id } = this

    let params = {
      merchantOrderId: Number(order_id),
      transWayChannel: TransWayChannel[payType]
    }
    let {
      RetCode,
      data: { orderNo, payNo, qrCode }
    } = await Api.pay(params)
    if (RetCode == 0) {
      runInAction(() => {
        this.payQrCode = qrCode
      })
      this.weiXinVisible = true
      if (orderNo) {
        this.checkIfWeixinPayed({ payNo, orderNo })
      }
    }
  }

  @observable timeout
  @action
  checkIfWeixinPayed = params => {
    const { return_url, payType, order_id } = this
    this.timeout = setInterval(async () => {
      let { data, success } = await Api.check_pay({
        payType,
        orderId: order_id,
        ...params
      })
      if (
        success &&
        (data.paySuccess || data.orderStatus === OrderStatusEnum.SUCCESS_DONE)
      ) {
        this.payStatus = true
        this.weiXinVisible = false
        clearInterval(this.timeout)
        message.success('支付成功！')
        setTimeout(() => {
          window.location.href = '#' + return_url
        }, 2000)
      }
    }, 2000)
  }

  @action
  payAlready = () => {
    const { return_url } = this
    window.location.href = '#' + return_url
  }
  @action
  beforeRouteEnter = async () => {
    const { data = {}, success } = await Api.findOrderInfo({
      orderId: this.order_id
    })
    if (success) {
      const { paidAmount, totalPayAmount } = data
      // 待支付金额大于等于订单金额，则此时不需要支付，自动跳转到订单详情页
      if (paidAmount >= totalPayAmount) {
        window.location.href = `#/localMerchant/purchaseHistory`
      }
    }
  }
}
export default new Store()
